<h4 class="auth-label">Mobile number</h4>
<p class="phone-hint">Select your country, then enter your mobile number{{ mobilePlaceholder ? ' e.g. ' + mobilePlaceholder : '' }}</p>
<ngx-intl-tel-input
  [cssClass]="'auth-input'"
  class="auth-input-wrapper"
  [preferredCountries]="[CountryIso.Australia, CountryIso.NewZealand]"
  [selectedCountryISO]="selectedCountry"
  [enableAutoCountrySelect]="true"
  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
  [enablePlaceholder]="true"
  [customPlaceholder]="mobilePlaceholder"
  (countryChange)="onCountryChange($event)"
  [searchCountryFlag]="true"
  [maxLength]="15"
  [phoneValidation]="true"
  name="phone"
  [formControl]="$any(control)"
>
</ngx-intl-tel-input>
<p class="form-error" style="padding-left: 1rem;" *ngIf="control.invalid && control.touched">{{ errorMessage }}</p>
